
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import Slider from "@/components/Reusable/Slider.vue";
import { RangeOptions } from "@/types/controls";
import Icon from "@/components/UI/Icon.vue";
import { parseFloatAndFixTo2Digits } from "@/util/math";

@Component({
  components: { Icon, TextInput, Slider }
})
export default class NumberInput extends Vue {
  @Prop()
  value!: number | null;

  @Prop()
  placeholder!: string | undefined;

  @Prop({ default: null })
  rangeOptions!: null | RangeOptions;

  @Prop({ default: true })
  arrows!: boolean;

  @Prop()
  disabled?: boolean;

  get step() {
    const step = this.rangeOptions?.step;

    // TODO: Remove this once `step` only accepts number
    if (typeof step === "string") {
      return parseFloat(step);
    }

    if (!step) {
      return 1;
    }

    return step;
  }

  get rangeEnabled() {
    return (
      typeof this.rangeOptions?.min === "number" &&
      typeof this.rangeOptions?.max === "number" &&
      this.rangeOptions?.disableSlider !== true
    );
  }

  increment() {
    const value = this.value || 0;
    this.edit(value + this.step);
  }

  decrement() {
    const value = this.value || 0;
    this.edit(value - this.step);
  }

  edit(newVal: number | string) {
    if (typeof newVal === "string") {
      this.$emit("input", parseFloatAndFixTo2Digits(newVal));
      this.$emit("focus");
      return;
    }

    // Don't allow NaN, at the same time, don't clear the input.
    if (isNaN(newVal)) {
      return;
    }

    this.$emit("input", newVal);
    this.$emit("focus");
  }
}
